import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FaChevronLeft, FaChevronDown } from "react-icons/fa";
import PatientAppointmentRequestCard from "./PatientAppointmentRequestCard";
import InputField from "./InputField";
import { IoMdSend } from "react-icons/io";
import { linearTopGradient } from "../constants/colors";
import { CgAttachment } from "react-icons/cg";
import AppointmentTimeInfo from "../Pages/AppointmentSummary/comps/AppointmentTimeInfo";
import { db } from "../config/firebaseConfig";
import { collection, getDocs, query } from "firebase/firestore";

const ChatModal = ({ isOpen, appointment, onClose, isUser }) => {
  const [isAppointmentDetailExpanded, setIsAppointmentDetailExpanded] = useState(false);
  const toggleAppointmentExpanded = () => setIsAppointmentDetailExpanded(!isAppointmentDetailExpanded);
  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const [user, setUser] = useState("User1");

  useEffect(() => {
    const q = query(collection(db, `appointmentChat/${appointment.appointment_number}/chat`));

    getDocs(q).then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        console.log(doc.data());
      });
    });

    // return () => unsubscribe();
  }, []);

  //   const sendMessage = async (e) => {
  //     e.preventDefault();

  //     if (messageInput.trim()) {
  //       await db.collection("messages").add({
  //         text: messageInput,
  //         user: user,
  //         timestamp: firebase.firestore.FieldValue.serverTimestamp(),
  //       });

  //       setMessageInput("");
  //     }
  //   };

  return (
    <ModalBackdrop onClick={() => onClose(false)}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <ModalHeader>
          <FaChevronLeft color="#000" size={22} onClick={() => onClose(false)} style={{ cursor: "pointer" }} />
          <strong className="text-dark">APTOYQ814145WVA</strong>
          <span>VC</span>
        </ModalHeader>

        {/* Modal Content */}
        <ModalContent>
          <AccordionHeader onClick={toggleAppointmentExpanded}>
            <span className="text-dark">Appointment Details</span>
            <FaChevronDown color="#000" size={14} />
          </AccordionHeader>
          <AccordionBody isActive={isAppointmentDetailExpanded}>
            {isAppointmentDetailExpanded && (
              <>
                <PatientAppointmentRequestCard
                  key={appointment.id}
                  name={appointment.user?.fullname}
                  image={appointment.user?.profile_image}
                  dateOfBirth={appointment.user?.dob}
                  appointmentDate={appointment.date}
                  appointmentTime={appointment.time}
                  gender={appointment.user?.gender}
                  showView={false}
                />
                <AppointmentTimeInfo date={appointment.date} time={appointment.time} type={appointment.type == 0 ? "Online" : "Clinic"} />
              </>
            )}
          </AccordionBody>
        </ModalContent>
        <div className="bottomItems">
          <div className="messageSendInput">
            <div className="input__Wrapper">
              <input type="text" placeholder="Write here...." />
              <IoMdSend color="#fff" className="sendIcon" size={36} />
            </div>
            <CgAttachment color="#fff" className="attachmentIcon ml-2" size={36} />
          </div>
        </div>
      </ModalContainer>
    </ModalBackdrop>
  );
};

export default ChatModal;

// Styled Components

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background: white;
  width: 100%;
  max-width: 500px;
  height: 100%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  animation: slide-up 0.4s ease-out;

  @media (min-width: 768px) {
    width: 50%;
    height: auto;
    animation: fade-in 0.3s ease-out;
  }

  @keyframes slide-up {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .messageSendInput {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 60px;
    width: 100%;
    background-color: #f7f7f7;
    z-index: 1000000;
  }
  .input__Wrapper {
    width: 90%;
    background-color: #ebebeb;
    display: flex;
    align-items: center;
    margin-right: 1rem;
    border-radius: 100px;
  }

  .messageSendInput {
    border-radius: 100px;
    display: flex;
    padding-left: 16px;
    padding-right: 16px;
    align-items: center;
    input {
      border: none;
      outline: none;
      padding: 8px 16px;
      width: 100%;
      background-color: transparent;
      color: #000;
    }

    .sendIcon {
      margin-left: auto;
    }

    .sendIcon,
    .attachmentIcon {
      background: ${linearTopGradient};
      padding: 8px;
      border-radius: 100px;
    }
  }
`;

const ModalHeader = styled.div`
  background: #f3f3f3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #ddd;

  strong {
    font-size: 16px;
    color: #000;
  }

  span {
    font-size: 14px;
    color: #555;
  }
`;

const ModalContent = styled.div`
  padding: 16px;
`;

const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 16px;
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background-color 0.3s ease;
  &:hover {
    background: #f1f1f1;
  }
`;

const AccordionBody = styled.div`
  max-height: ${({ isActive }) => (isActive ? "200px" : "0")};
  overflow: hidden;
  transition: max-height 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);

  div {
    opacity: ${({ isActive }) => (isActive ? 1 : 0)};
    transition: opacity 0.3s ease;
  }
`;
